export default __webpack_public_path__ + "static/media/litho-demo-photography.719b275e.jpg";